import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Notifier, useNotifierContext } from '@app/common/components/Notifier';

import styles from './NotifierWrapper.pcss';

export const NotifierWrapper: React.FC = () => {
  const { clearAlerts, resolveQueue } = useNotifierContext();
  const location = useLocation();

  useEffect(() => {
    clearAlerts();
    resolveQueue();
  }, [location]);

  return (
    <Notifier className={styles.alertsWrapper} />
  );
};
